import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getCoinInfo, getPresaleStats } from "@/lib/api";

function formatUSD(n) {
  if (n == null) return "--";
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${n.toFixed(2)}`;
}

export default function LiveStats() {
  const [info, setInfo] = useState(null);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    Promise.all([getCoinInfo(), getPresaleStats()])
      .then(([i, s]) => { setInfo(i); setStats(s); })
      .catch(() => {});
  }, []);

  const items = [
    { label: "ARC Price", value: info ? `$${info.presale_price_usd.toFixed(3)}` : "--", accent: "text-[#39FF14]", testid: "stat-price" },
    { label: "Market Cap", value: info ? formatUSD(info.market_cap_usd) : "--", accent: "text-white", testid: "stat-mcap" },
    { label: "Holders", value: stats ? stats.contributors.toLocaleString() : (info ? info.holders.toLocaleString() : "--"), accent: "text-[#00F0FF]", testid: "stat-holders" },
    { label: "24h Volume", value: info ? formatUSD(info.volume_24h_usd) : "--", accent: "text-white", testid: "stat-volume" },
    { label: "24h Change", value: info ? `+${info.price_change_24h.toFixed(2)}%` : "--", accent: "text-[#39FF14]", testid: "stat-change" },
    { label: "Total Supply", value: info ? (info.total_supply >= 1_000_000_000 ? `${(info.total_supply / 1_000_000_000).toFixed(0)}B` : `${(info.total_supply / 1_000_000).toFixed(0)}M`) : "--", accent: "text-white", testid: "stat-supply" },
  ];

  return (
    <section className="relative py-16" data-testid="live-stats-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#00F0FF]">// terminal feed</p>
            <h2 className="font-display text-2xl sm:text-3xl font-black mt-1">LIVE ARC METRICS</h2>
          </div>
          <div className="hidden sm:flex items-center gap-2 text-white/50">
            <span className="w-2 h-2 rounded-full bg-[#39FF14] pulse-dot" />
            <span className="font-mono text-[10px] uppercase tracking-[0.3em]">streaming</span>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {items.map((it, i) => (
            <motion.div
              key={it.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="glass p-4"
              data-testid={it.testid}
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">{it.label}</div>
              <div className={`font-display text-xl sm:text-2xl font-bold mt-2 ${it.accent}`}>{it.value}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
